export const parseFormattedNumber = (value: null | string): null | number => {
  return value ? parseFloat(value.replace(/[^\d.-]/g, '')) : null
}

export const formatCurrency = (value: number | string): null | string => {
  return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
